import Vue from 'vue';
const b = 'c-contractor-search';
Vue.component('contractor-search-filter', {
  props: {
    value: undefined,
    filter: Object,
  },

  data: function() {
    return {
      checkedProxy: false,
      tooltipVisible: false,
    };
  },

  computed: {
    checked: {
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.checkedProxy = val;
      },
    },
  },

  methods: {
    onChange: function() {
      this.$emit('input', this.checkedProxy);
    },

    toggleTooltip: function() {
      this.tooltipVisible = !this.tooltipVisible;
    },
  },

  template: `
  <div class="${b}__filter-option">
    <input class="${b}__filter-radio"
      v-model="checked"
      @change="onChange"
      :value="filter.key"
      :id="'filter-' + filter.key"
      :name="'filter-' + filter.key"
      type="checkbox"
    ><label :for="'filter-' + filter.key"></label>
    <div class="${b}__filter-row">
      <div class="${b}__filter-label">
        <label
          :for="'filter-' + filter.key">{{filter.title}}
        </label>
        <span 
          class="${b}__tooltip" 
          :class="{ '${b}__tooltip--is-active': tooltipVisible }" 
          v-on:click="toggleTooltip">
        </span>
      </div>
      <p class="${b}__tooltip-text" v-if="tooltipVisible">
        {{filter.description}}
      </p>
    </div>
  </div>`,
});


// WEBPACK FOOTER //
// ./scripts/vue-components/contractor-search-filter.js